import pencilIcon from '../../assets/icons/pencil.svg';

type Props = {
  onClick?: React.MouseEventHandler;
};

/**
 * An EditButton component
 * @param props
 */
let EditButton = (props: Props) => {
  return (
    <img className="EditButton" src={pencilIcon} alt="Edit" onClick={props.onClick || undefined} />
  );
};

export default EditButton;
